
namespace RioERP.Masters {
    export class DtdcApiDetailsColumns {
        static columnsKey = 'Masters.DtdcApiDetails';
    }
}